import { useEffect, useState } from "react"

interface Props {
  threshold?: number
}

const useScroll = ({ threshold = 0 }: Props): boolean => {
  const [isScrolled, setIsScrolled] = useState<boolean>(false)

  useEffect(() => {
    const onScroll = (): void => {
      const scrollCheck: boolean = window.scrollY > threshold
      if (scrollCheck !== isScrolled) {
        setIsScrolled(scrollCheck)
      }
    }

    document.addEventListener("scroll", onScroll)

    return () => {
      document.removeEventListener("scroll", onScroll)
    }
  }, [isScrolled, setIsScrolled, threshold])

  return isScrolled
}

export default useScroll
